@use "variables" as *;

.itemDiv {
  width: 100%;
  padding-left: $spacing-m;
  padding-right: $spacing-m;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title {
  font-size: $fontSize-s;
  padding-top: $spacing-s;
}

.value {
  font-size: $fontSize-m;
  font-weight: bold;
}

.loadingIndicator {
  width: 14px !important;
  height: 14px !important;
}

.toggleButton {
  width: 40px;
}
